import { useState } from 'react';
import { t, type MessageKey } from '../i18n';
import type { DateRangePreset } from '../types/analytics';
import { useDashboard } from '../context/DashboardContext';
import { rangeFromPreset, todayInReportingTimezone } from '../utils/dateRange';

const presets: Array<{ id: Exclude<DateRangePreset, 'custom'>; label: MessageKey }> = [
  { id: 'today', label: 'v1.range.today' }, { id: 'yesterday', label: 'v1.range.yesterday' }, { id: '7d', label: 'v1.range.7d' }, { id: '30d', label: 'v1.range.30d' },
];

export function DateRangeSelector() {
  const { range, setRange } = useDashboard();
  const [custom, setCustom] = useState(false);
  const [start, setStart] = useState(range.start);
  const [end, setEnd] = useState(range.end);
  // A range cannot reach into the future: both inputs stop at today in the reporting timezone.
  const today = todayInReportingTimezone();
  const invalid = !start || !end || start > end || end > today;

  return (
    <div className="range-control" aria-label={t('v1.range.label')}>
      {presets.map((preset) => <button key={preset.id} className={range.preset === preset.id ? 'active' : ''} onClick={() => { setCustom(false); setRange(rangeFromPreset(preset.id)); }}>{t(preset.label)}</button>)}
      <button className={range.preset === 'custom' ? 'active' : ''} onClick={() => setCustom((value) => !value)}>{t('v1.range.custom')}</button>
      {custom && <div className="custom-range">
        <label>{t('v1.range.from')}<input aria-label={t('v1.range.startDate')} type="date" value={start} max={end < today ? end : today} onChange={(event) => setStart(event.target.value)} /></label>
        <label>{t('v1.range.to')}<input aria-label={t('v1.range.endDate')} type="date" value={end} min={start} max={today} onChange={(event) => setEnd(event.target.value)} /></label>
        <button className="apply" disabled={invalid} onClick={() => { if (invalid) return; setRange({ preset: 'custom', start, end, timezone: range.timezone }); setCustom(false); }}>{t('v1.range.apply')}</button>
      </div>}
    </div>
  );
}
